module.exports = __webpack_public_path__ + "img/gate_passed_badge.d2a17f5.svg";